function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.29995 12.7L7.99995 13.4L9.39995 12L8.69995 11.3C7.69995 10.3 7.69995 8.7 8.69995 7.7L11.7 4.7C12.7 3.7 14.3 3.7 15.3 4.7C16.3 5.7 16.3 7.3 15.3 8.3L14.6 9L16 10.4L16.7 9.7C18.5 7.9 18.5 5.1 16.7 3.3C15.8 2.5 14.7 2 13.5 2C12.3 2 11.2 2.4 10.3 3.3L7.29995 6.3C5.49995 8.1 5.49995 10.9 7.29995 12.7ZM3.29995 16.7C4.19995 17.5 5.29995 18 6.49995 18C7.69995 18 8.89995 17.5 9.69995 16.7L12.7 13.7C14.5 11.9 14.5 9.10001 12.7 7.30001L12 6.60001L10.6 8.00001L11.3 8.70001C12.3 9.70001 12.3 11.3 11.3 12.3L8.29995 15.3C7.29995 16.3 5.69995 16.3 4.69995 15.3C3.69995 14.3 3.69995 12.7 4.69995 11.7L5.39995 11L3.99995 9.60001L3.29995 10.3C1.49995 12.1 1.49995 14.9 3.29995 16.7Z",
  fill: "currentColor"
});

function SvgAttachHyperlink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachHyperlink);
export default __webpack_public_path__ + "static/media/attach-hyperlink.baff81d3.svg";
export { ForwardRef as ReactComponent };